import { addProvider, metadataModuleProvider } from './metaData';
import calibratedPixelSpacingMetadataProvider from './utilities/calibratedPixelSpacingMetadataProvider';
import { registerCacheProviders } from './utilities/metadataProvider/cacheData';
import { registerUriModule } from './utilities/metadataProvider/uriModule';
import { registerDataLookup } from './utilities/metadataProvider/dataLookup';
import { registerInstanceFromListener } from './utilities/metadataProvider/instanceFromListener';
import { registerCombineFrameProvider } from './utilities/metadataProvider/combineFrameInstance';
import { clearTagModules, registerTagModules, } from './utilities/metadataProvider/tagModules';
import { registerImagePlaneCalibrated } from './utilities/metadataProvider/imagePlaneCalibrated';
import { registerCalibrationModule } from './utilities/metadataProvider/calibrationModule';
import { registerPixelDataUpdate } from './utilities/metadataProvider/pixelDataUpdate';
import { registerTransferSyntaxProvider } from './utilities/metadataProvider/transferSyntaxProvider';
import { registerEcgFromInstanceProvider } from './utilities/metadataProvider/ecgFromInstance';
import { registerCompressedFrameDataProvider } from './utilities/metadataProvider/compressedFrameData';
import { registerScalingFromInstanceProvider } from './utilities/metadataProvider/scalingFromInstance';
import { registerNaturalizedHandlers } from './utilities/metadataProvider/naturalizedHandlers';
import { registerImageIdProviders } from './utilities/metadataProvider/imageIdsProviders';
const TYPED_PROVIDER_BRIDGE_PRIORITY = -1000;
export function registerDefaultProviders() {
    addProvider(metadataModuleProvider, TYPED_PROVIDER_BRIDGE_PRIORITY);
    addProvider(calibratedPixelSpacingMetadataProvider.get);
    clearTagModules();
    registerCacheProviders();
    registerNaturalizedHandlers();
    registerUriModule();
    registerImageIdProviders();
    registerDataLookup();
    registerInstanceFromListener();
    registerCombineFrameProvider();
    registerTagModules();
    registerEcgFromInstanceProvider();
    registerImagePlaneCalibrated();
    registerCalibrationModule();
    registerPixelDataUpdate();
    registerTransferSyntaxProvider();
    registerCompressedFrameDataProvider();
    registerScalingFromInstanceProvider();
}
